import { useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import CommonCard from "../../../global/card";
import CommonSkeletonLoader from "../../../global/loading";
import CommonPagination from "../../../global/pagination";
import useDebounce from "../../../../utils/customHooks";
import SOURCES from "../../../../utils/constants";
import { QUERY_KEYS } from "../../../../lib/query-constants";
import { useGenericQuery } from "../../../../queries/use-generic-query";
import EnhanceAffiliateList from "./enhance-affiliate-list";
import AddAffiliates from "./add-affiliates";
import CommonDialog from "../../../global/dialog";

const EnhanceAffliates = () => {
    const [searchAffiliate, setSearchAffiliate] = useState("");
    const [editDeleteAdd, setEditDeleteAdd] = useState({
        id: null,
        action: null,
        del: false,
        editAdd: false,
        isEditAble: false,
    });
    const [affiliatesViewType, setAffiliatesViewType] = useState(() => {
        return localStorage.getItem("affiliatesViewType") || "GRID";
    });
    const [sort, setSort] = useState({ sortType: "", sortOrder: 1 });

    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(searchParams.get("page") || 1, 10);
    const limitFromQuery = parseInt(
        searchParams.get("limit") || SOURCES.DEFAULT_RECORDS_LISTING,
        24
    );
    const offsetFromQuery = parseInt(searchParams.get("offset") || "0", 10);

    const [pagination, setPagination] = useState({
        offset: offsetFromQuery,
        limit: limitFromQuery,
        page: pageFromQuery,
    });

    const debouncedSearchTerm = useDebounce(searchAffiliate, 500);

    const keyParams = useMemo(
        () => ({
            offset: pagination.offset,
            limit: pagination.limit,
            sortBy: sort.sortType,
            sortOrder: sort.sortOrder,
        }),
        [pagination.offset, pagination.limit, sort.sortType, sort.sortOrder]
    );

    const { data, isLoading, isFetching } = useGenericQuery({
        endpoint: "affiliate",
        queryKey: QUERY_KEYS.affiliates.lists({ ...keyParams }),
        queryParams: { ...keyParams },
        onError: () => { },
        onSuccess: () => { },
    });

    const { data: searchAffiliateData, isInitialLoading: searchAffiliateLoading } =
        useGenericQuery({
            endpoint: "affiliate/search",
            queryKey: QUERY_KEYS.affiliates.lists({ q: debouncedSearchTerm }),
            queryParams: { q: debouncedSearchTerm },
            onError: () => { },
            onSuccess: () => { },
            enabled: !!debouncedSearchTerm,
        });

    const isLoadingList = isLoading || searchAffiliateLoading;

    const finalizedAffiliates = useMemo(() => {
        if (
            searchAffiliateData?.results &&
            Array.isArray(searchAffiliateData?.results)
        ) {
            return searchAffiliateData.results;
        }

        if (data?.results && Array.isArray(data.results)) {
            return data.results;
        }

        return [];
    }, [data, searchAffiliateData]);

    return (
        <CommonCard
            isSearch={{
                show: true,
                placeholder: "Search affiliates...",
                searchInput: searchAffiliate,
                setSearchInput: setSearchAffiliate,
            }}
            isListGridView={{
                show: true,
                setViewType: setAffiliatesViewType,
                viewFor: "affiliatesViewType",
                viewType: affiliatesViewType,
            }}
            isCreateButton={{
                show: true,
                text: "Add Affiliates / Partners",
                onclick: () => {
                    setEditDeleteAdd({
                        ...editDeleteAdd,
                        editAdd: true,
                    })
                }
            }}
            isLoading={{
                show: isLoadingList,
                loaderCmp: (
                    <CommonSkeletonLoader
                        rows={9}
                        type={affiliatesViewType === "GRID" ? "card" : "table"}
                        tableLength={7}
                    />
                ),
            }}
            className={(!isLoading && isFetching) && "opacity-50"}
        >
            <EnhanceAffiliateList
                affiliates={finalizedAffiliates}
                viewType={affiliatesViewType}
                sort={sort}
                setSort={setSort}
                isLoading={isLoadingList}
                keyParams={keyParams}
                editDeleteAdd={editDeleteAdd}
                setEditDeleteAdd={setEditDeleteAdd}
            />

            {
                Array.isArray(data?.results) &&
                data.results.length > 0 &&
                !searchAffiliate && (
                    <CommonPagination
                        currentPage={pagination.page}
                        defaultLimit={pagination.limit}
                        totalRecords={data?.totalRecords || data?.count}
                        setCurrentPage={setPagination}
                        activePageRecords={
                            Array.isArray(finalizedAffiliates)
                                ? finalizedAffiliates.length
                                : 0
                        }
                        paginationFor="Affiliates"
                        className="mt-4"
                    />
                )
            }
            {
                editDeleteAdd.editAdd && (
                    <AddAffiliates
                        editDeleteAdd={editDeleteAdd}
                        setEditDeleteAdd={setEditDeleteAdd}
                        keyParams={keyParams}
                    />
                )
            }
        </CommonCard >
    );
};

export default EnhanceAffliates;